import { posDraftStorageKey } from '@/utils/storageKeys';

export { posDraftStorageKey };

export function leerPosDraft(usuario) {
    try {
        const raw = localStorage.getItem(posDraftStorageKey(usuario));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return null;
        return parsed;
    } catch (_) {
        return null;
    }
}

export function guardarPosDraft(usuario, draft) {
    if (!usuario) return;
    try {
        localStorage.setItem(
            posDraftStorageKey(usuario),
            JSON.stringify({
                cantidades: draft.cantidades || {},
                preciosPos: draft.preciosPos || {},
                itemsLibres: Array.isArray(draft.itemsLibres) ? draft.itemsLibres : [],
                scan: String(draft.scan || ''),
                categoriaActiva: String(draft.categoriaActiva || 'Todos'),
                updatedAt: Date.now(),
            }),
        );
    } catch (_) {
        /* ignore quota errors */
    }
}

export function limpiarPosDraft(usuario) {
    if (!usuario) return;
    try {
        localStorage.removeItem(posDraftStorageKey(usuario));
    } catch (_) {
        /* ignore */
    }
}

export function normalizarCantidadesPos(cantidades, productos) {
    const ids = new Set((productos || []).map((p) => String(p.producto_id)));
    const out = {};
    for (const [id, q] of Object.entries(cantidades || {})) {
        if (!ids.has(String(id))) continue;
        let n = Math.max(0, Math.floor(Number(q) || 0));
        if (n <= 0) continue;
        const p = productos.find((x) => String(x.producto_id) === String(id));
        if (!p) continue;
        const stock = Number(p.producto_stock);
        if (stock !== -1 && n > stock) n = stock;
        if (n > 0) out[id] = n;
    }
    return out;
}
